import { create } from "zustand";
import { persist } from "zustand/middleware";
import { DEFAULT_TYPING, type TypingTiming } from "@hamlak/ui/typewriter";
import type { AppSettings } from "@/api/types";

type ConfigState = {
  /** GET /api/app/settings 응답 전체. 시작마다 재조회하고 실패 시 persist 캐시를 쓴다. */
  settings: AppSettings | null;
  fetchedAt: number | null;
  setSettings: (settings: AppSettings) => void;
};

export const useConfigStore = create<ConfigState>()(
  persist(
    (set) => ({
      settings: null,
      fetchedAt: null,
      setSettings: (settings) => set({ settings, fetchedAt: Date.now() }),
    }),
    { name: "hamlak.config" },
  ),
);

export const selectPricing = (s: ConfigState) => s.settings?.pricing ?? null;

/** 채팅 타이핑 속도(AC0-326). 시작 때 받은 서버 값, 없으면(구 서버·persist 캐시) 기본값. TypeBuffer 가 글자마다 읽는다 */
export const currentTyping = (): TypingTiming => useConfigStore.getState().settings?.chatTyping ?? DEFAULT_TYPING;
